var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickChaussette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 61.48,
    height: 59.367,
    viewBox: "0 0 61.48 59.367",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 61.48,
    height: 59.367,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_271",
    "data-name": "Groupe 271",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_270",
    "data-name": "Groupe 270",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_533",
    "data-name": "Trac\\xE9 533",
    d: "M42.054,14.271a.865.865,0,0,1-.125-.009.881.881,0,0,1-.737-1L42.974.755a.871.871,0,1,1,1.724.251L42.915,13.516a.875.875,0,0,1-.861.755",
    transform: "translate(-5.334 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_534",
    "data-name": "Trac\\xE9 534",
    d: "M49.881,21.14a.869.869,0,0,1-.672-.318.892.892,0,0,1,.114-1.242L57.3,12.873a.863.863,0,0,1,1.227.115.891.891,0,0,1-.114,1.241l-7.982,6.709a.858.858,0,0,1-.555.2",
    transform: "translate(-6.347 -1.504)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_535",
    "data-name": "Trac\\xE9 535",
    d: "M53.583,30.491a.881.881,0,0,1,0-1.762l12.1-.055h0a.881.881,0,0,1,0,1.762l-12.1.055Z",
    transform: "translate(-6.827 -3.405)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_536",
    "data-name": "Trac\\xE9 536",
    d: "M31.178,64.485c-3.841,0-7.741-3.01-9.422-7.65a12.437,12.437,0,0,1-.1-8.51,7.921,7.921,0,0,1,4.573-4.776,7.85,7.85,0,0,1,6.965.9,12.287,12.287,0,0,1,4.933,6.308c2.047,5.651.041,11.61-4.473,13.287a7.088,7.088,0,0,1-2.477.442m-2.45-19.621a5.434,5.434,0,0,0-1.9.338,6.2,6.2,0,0,0-3.547,3.756,10.635,10.635,0,0,0,.108,7.27c1.717,4.736,6.047,7.5,9.666,6.16s5.155-6.288,3.438-11.025a10.544,10.544,0,0,0-4.21-5.413,6.771,6.771,0,0,0-3.556-1.087",
    transform: "translate(-2.714 -5.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_537",
    "data-name": "Trac\\xE9 537",
    d: "M63.722,53.63a.871.871,0,0,1-.836-.635.882.882,0,0,1,.593-1.092c3.085-.909,4.463-3.85,3.78-8.07-.652-4.038-3.737-6.905-6.868-6.38a.882.882,0,0,1-.28-1.74c4.081-.679,8.059,2.838,8.868,7.837.828,5.123-1.045,8.879-5.013,10.046a.861.861,0,0,1-.243.035",
    transform: "translate(-7.69 -4.23)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_538",
    "data-name": "Trac\\xE9 538",
    d: "M59.355,37.634a.882.882,0,0,1-.2-1.738l.616-.152a.869.869,0,0,1,1.052.649.882.882,0,0,1-.641,1.065l-.616.152a.879.879,0,0,1-.206.025",
    transform: "translate(-7.574 -4.241)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_539",
    "data-name": "Trac\\xE9 539",
    d: "M28.66,44.056a.882.882,0,0,1-.2-1.739l26.72-6.4a.869.869,0,0,1,1.047.654.88.88,0,0,1-.646,1.06l-26.721,6.4a.876.876,0,0,1-.2.024",
    transform: "translate(-3.599 -4.262)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_540",
    "data-name": "Trac\\xE9 540",
    d: "M64.238,55.779a.871.871,0,0,1-.821-.589.883.883,0,0,1,.532-1.124l.83-.3a.871.871,0,0,1,1.11.538.882.882,0,0,1-.532,1.124l-.83.3a.872.872,0,0,1-.289.05",
    transform: "translate(-8.207 -6.379)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_541",
    "data-name": "Trac\\xE9 541",
    d: "M34.321,65.571A.869.869,0,0,1,33.506,65a.882.882,0,0,1,.514-1.132L60.062,54.11a.862.862,0,0,1,1.118.521.882.882,0,0,1-.514,1.132L34.624,65.516a.869.869,0,0,1-.3.055",
    transform: "translate(-4.332 -6.419)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_542",
    "data-name": "Trac\\xE9 542",
    d: "M36.461,39.3c-3.434,0-7.09-2.225-9.252-6.01-2.976-5.21-2.012-11.432,2.149-13.867a7.785,7.785,0,0,1,6.552-.5A12.171,12.171,0,0,1,42.3,24.454c2.976,5.21,2.012,11.431-2.149,13.867a7.24,7.24,0,0,1-3.693.982M28.715,32.41c2.5,4.368,7.237,6.334,10.567,4.387s4.01-7.091,1.516-11.46A10.4,10.4,0,0,0,35.351,20.6a6.082,6.082,0,0,0-5.121.353C26.9,22.9,26.22,28.042,28.715,32.41",
    transform: "translate(-3.3 -2.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_543",
    "data-name": "Trac\\xE9 543",
    d: "M9.642,55.594a9.531,9.531,0,0,1-7.1-3.7,10.28,10.28,0,0,1-2.54-6.272,7.007,7.007,0,0,1,2.273-5.642.862.862,0,0,1,1.227.09.887.887,0,0,1-.088,1.243,5.268,5.268,0,0,0-1.672,4.249,8.5,8.5,0,0,0,2.115,5.178c2.772,3.24,6.339,4.01,9.087,1.961a.864.864,0,0,1,1.217.188.889.889,0,0,1-.185,1.232,7.188,7.188,0,0,1-4.338,1.471",
    transform: "translate(0 -4.722)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_544",
    "data-name": "Trac\\xE9 544",
    d: "M3.27,41.341a.868.868,0,0,1-.7-.356.891.891,0,0,1,.181-1.234l.508-.381a.864.864,0,0,1,1.219.183A.89.89,0,0,1,4.3,40.787l-.508.382a.86.86,0,0,1-.518.173",
    transform: "translate(-0.311 -4.654)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_545",
    "data-name": "Trac\\xE9 545",
    d: "M3.854,38.713a.865.865,0,0,1-.7-.353.888.888,0,0,1,.174-1.234L25.3,20.448a.861.861,0,0,1,1.218.177.887.887,0,0,1-.174,1.233L4.376,38.537a.858.858,0,0,1-.521.176",
    transform: "translate(-0.386 -2.407)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_546",
    "data-name": "Trac\\xE9 546",
    d: "M13.811,56.8a.869.869,0,0,1-.749-.43.887.887,0,0,1,.3-1.208l.756-.456a.866.866,0,0,1,1.194.307.888.888,0,0,1-.3,1.208l-.756.455a.857.857,0,0,1-.445.124",
    transform: "translate(-1.676 -6.481)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_547",
    "data-name": "Trac\\xE9 547",
    d: "M14.679,55.856a.867.867,0,0,1-.756-.442.886.886,0,0,1,.321-1.2l6.2-3.605a.864.864,0,0,1,1.188.325.885.885,0,0,1-.321,1.2l-6.2,3.605a.859.859,0,0,1-.433.117",
    transform: "translate(-1.788 -5.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_548",
    "data-name": "Trac\\xE9 548",
    d: "M39.085,42.1a.867.867,0,0,1-.756-.442.886.886,0,0,1,.321-1.2L41.483,38.8a.864.864,0,0,1,1.188.325.886.886,0,0,1-.321,1.2l-2.832,1.647a.859.859,0,0,1-.433.117",
    transform: "translate(-4.949 -4.594)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickChaussette);
export default __webpack_public_path__ + "static/media/STICK_CHAUSSETTE.af518ae9a2d60de65c93583bc5a3e5f1.svg";
export { ForwardRef as ReactComponent };